import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDirection2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="direction-2, route"><path d="M12 3C11.5858 3 11.25 3.33579 11.25 3.75V8.25H5.25C3.45507 8.25 2 9.70507 2 11.5C2 13.2949 3.45507 14.75 5.25 14.75H11.25V19.5H7.75C7.33579 19.5 7 19.8358 7 20.25C7 20.6642 7.33579 21 7.75 21H16.25C16.6642 21 17 20.6642 17 20.25C17 19.8358 16.6642 19.5 16.25 19.5H12.75V9.75H18.625C20.489 9.75 22 8.23896 22 6.375C22 4.51104 20.489 3 18.625 3H12Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDirection2;
